import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../../components/ui/sheet.jsx";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar.jsx";
import { Button } from "../../components/ui/button";
import { useSelector } from "react-redux";
import { BarChart3, Phone, UserPlus } from "lucide-react";
import { useState } from "react";
import { Input } from "../../components/ui/input.jsx";
import { useQuantityContext } from "../../../../../../Components/QuantityContext.js";
import { useDispatch } from "react-redux";
import {
  getContactGroupReducer,
  postEditContactGroupReducer,
} from "../../../../../../Redux/Reducers/ContactReducer.js";
import { useUserDetailContext } from "Components/UserDetailContext.js";
import VideoChatRoundedIcon from "@mui/icons-material/VideoChatRounded";

export default function ChatInfoSheet({ infoSheetOpen, setInfoSheetOpen }) {
  const dispatch = useDispatch();
  const { userDetails } = useUserDetailContext();
  const { openSnackbar } = useQuantityContext();
  const [inviteEmails, setInviteEmails] = useState("");
  const currentConversation = useSelector(
    (state) => state?.cce?.currentConversation
  );
  const groupMembersData = useSelector(
    (state) => state?.ContactArray?.groupMembersData
  );

  // console.log("UserDetails123", userDetails);

  const groupmembers = groupMembersData?.members;

  const isAdmin = groupmembers?.some(
    (el) =>
      userDetails?.reference_id == el.contact_ref_id &&
      el.contact_role === "ADMIN"
  );

  // console.log("groupmembers",  currentConversation?.sourceType);
  const Connectedcontact = useSelector(
    (state) => state?.ContactArray?.ConnectedContact
  );
  const groupMemberIds =
    (currentConversation.sourceType == "group" &&
      groupMembersData.members?.map((m) => m.contact_ref_id)) ||
    [];

  const filteredContacts = Connectedcontact.filter(
    (contact) => !groupMemberIds?.includes(contact.contact_ref_id)
  );

  const GroupMembersData = Connectedcontact.filter((contact) =>
    groupMemberIds?.includes(contact.contact_ref_id)
  );

  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };
  const conversationName = currentConversation?.title;
  const conversationAvatar = currentConversation?.avatar;

  // console.log("currentConversation-11", currentConversation)

  const startCall = () => {
    const room = `channel:${conversationName.toLowerCase()}`;
    window.location.href = `/call?room=${encodeURIComponent(room)}`;
  };

  const handleInviteEmail = async () => {
    try {
      const reqBody = {
        emailList: Array.isArray(inviteEmails) ? inviteEmails : [inviteEmails],
        name: "",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/mail/send-email-invite`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(reqBody),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("✅ Email invite sent successfully:", data);
        setInviteEmails("");
        openSnackbar("Invited successfully!", "success");
        setInfoSheetOpen(false);
      } else {
        console.error("❌ Failed to send invite:", data);
      }
    } catch (error) {
      console.error("🚨 Error sending invite:", error);
    }
  };

  const handleAddContacttoGroup = async (user) => {
    //   console.log("IAM From inside fun", user);
    try {
      const formData = new FormData();
      const payload = groupMembersData?.groupDetails || {};
      formData.append("group_name", payload?.group_name);
      formData.append("group_type", payload?.group_type || "CONTACT");
      formData.append("group_category", payload?.group_category || "");
      formData.append("group_subname", payload?.group_subname || "");
      formData.append("group_desc", payload?.group_desc || "");
      formData.append("group_id", payload?.group_id || currentConversation?.id);

      // handle group image
      if (payload?.group_image || currentConversation?.avatar) {
        try {
          const response = await fetch(currentConversation?.avatar);
          const blob = await response.blob();
          formData.append("profile_pic", blob);
        } catch (error) {
          console.log("Error", error);
        }
      }

      // append members (from payload)
      if (groupMembersData?.members) {
        [...groupMembersData?.members, user].forEach((member) => {
          const memberId = member?.contact_ref_id || member?.user_ref_id;
          console.log("membersis", memberId);
          formData.append("members[]", memberId);
        });
      }

      console.log("📦 FormData contents:");
      for (const [key, value] of formData.entries()) {
        console.log(key, value);
      }
      // dispatch API call
      const response = await dispatch(postEditContactGroupReducer(formData));

      // handle success
      if (response?.payload?.data?.statusCode === 200) {
        console.log("✅ Group Updated Successfully");
        await dispatch(getContactGroupReducer());

        setInfoSheetOpen(false);
        openSnackbar("Contact added successfully!", "success");
      } else {
        console.error("❌ API Error:", response);
      }
    } catch (error) {
      console.error("Error in handleAddContacttoGroup:", error);
    }
  };

  return (
    <div>
      <Sheet open={infoSheetOpen} onOpenChange={setInfoSheetOpen}>
        <SheetContent
          side="right"
          className="z-[999] w-[360px] sm:w-[420px] h-[calc(100vh-6rem)] overflow-y-auto bg-white text-[#e9edef] rounded-xl mt-24 mr-1 pb-10 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100"
        >
          <SheetHeader>
            <SheetTitle className="text-left text-lg font-semibold">
              Conversation details
            </SheetTitle>
          </SheetHeader>
          <div className="mt-4 space-y-6 text-sm">
            {currentConversation?.sourceType == "group" && (
              <div className="flex items-center gap-3 rounded-2xl border border-[#1f2c34] bg-[#f4f7fe] text-[black] p-4">
                <Avatar className="h-14 w-14">
                  <AvatarImage
                    src={conversationAvatar}
                    alt={conversationName}
                    referrerPolicy="no-referrer"
                  />
                  <AvatarFallback>
                    {conversationName.slice(0, 2).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="min-w-0 flex-1">
                  <div className="text-base font-semibold">
                    {conversationName}
                  </div>
                </div>
                <Button
                  size="sm"
                  className="text-white bg-[#0044C6] hover:bg-[#3366D9]"
                  onClick={startCall}
                >
                  <Phone className="mr-2 h-3.5 w-3.5" /> Call
                </Button>
              </div>
            )}

            {currentConversation?.sourceType == "direct" && (
              <div className="flex flex-col items-center gap-3 rounded-2xl border border-[#1f2c34] bg-[#f4f7fe] text-black p-6 w-full max-w-sm mx-auto shadow-md">
                {/* Profile Avatar */}
                <Avatar className="h-20 w-20">
                  <AvatarImage
                    src={conversationAvatar}
                    alt={conversationName}
                    referrerPolicy="no-referrer"
                  />
                  <AvatarFallback>
                    {conversationName?.slice(0, 2).toUpperCase()}
                  </AvatarFallback>
                </Avatar>

                {/* Profile Name */}
                <div className="text-center">
                  <div className="text-lg font-semibold">
                    {conversationName}
                  </div>
                  <div className="text-sm text-gray-600">{currentConversation?.isOnline ?  "Online": "Away"}</div>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-3 mt-3">
                  <Button
                    size="sm"
                    className="flex items-center gap-2 text-white bg-[#0044C6] hover:bg-[#3366D9]"
                    onClick={startCall}
                  >
                    <Phone className="h-4 w-4" />
                    Call
                  </Button>

                  <Button
                    size="sm"
                    className="flex items-center gap-2 text-white bg-[#0044C6] hover:bg-[#3366D9]"
                    // onClick={startVideoCall}
                  >
                    <VideoChatRoundedIcon className="h-4 w-4" />
                    Video Call
                  </Button>
                </div>
              </div>
            )}

            <div className="space-y-4">
              {isAdmin && currentConversation?.sourceType == "group" && (
                <div className="rounded-2xl border border-[#1f2c34] bg-[#f4f7fe] text-[black] p-4">
                  <div className="text-sm font-semibold">Invite via email</div>
                  <div className="mt-3 flex gap-2">
                    <Input
                      placeholder="alice@example.com, bob@corp.com"
                      value={inviteEmails}
                      onChange={(event) => setInviteEmails(event.target.value)}
                    />
                    <Button
                      size="sm"
                      disabled={!inviteEmails.trim()}
                      onClick={handleInviteEmail}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              )}

              {isAdmin &&
                filteredContacts?.length > 0 &&
                currentConversation?.sourceType == "group" && (
                  <div className="rounded-2xl border border-[#1f2c34] bg-[#f4f7fe] text-[black] p-4">
                    <div className="text-sm font-semibold">
                      Add from contacts
                    </div>
                    <ul className="mt-3 space-y-2">
                      {(filteredContacts?.length
                        ? filteredContacts?.slice(0, 6)
                        : []
                      ).map((user) => {
                        const label =
                          `${user?.first_name} ${user?.last_name}` || "Member";
                        return (
                          <li
                            key={user?.id || label}
                            className="flex items-center justify-between rounded-xl border border-[#1f2c34] bg-[white] px-3 py-2"
                          >
                            <div className="flex items-center gap-3">
                              <Avatar className="h-8 w-8">
                                <AvatarImage
                                  src={user?.profile_url}
                                  alt={label}
                                  referrerPolicy="no-referrer"
                                />
                                <AvatarFallback>
                                  {label.slice(0, 2).toUpperCase()}
                                </AvatarFallback>
                              </Avatar>
                              <div>
                                <div className="text-sm font-medium">
                                  {label}
                                </div>
                                {user?.email && (
                                  <div className="text-[11px] text-[#8696a0]">
                                    {user?.email}
                                  </div>
                                )}
                              </div>
                            </div>
                            <Button
                              variant="contained"
                              size="sm"
                              onClick={() => handleAddContacttoGroup(user)}
                              sx={{
                                backgroundColor: "#0044C6",
                                color: "white",
                                "&:hover": {
                                  backgroundColor: "#003bb0",
                                },
                              }}
                            >
                              Add
                            </Button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}

              {currentConversation?.sourceType == "group" && (
                <div className="rounded-2xl border border-[#1f2c34] bg-[#f4f7fe] text-[black] p-4">
                  <div className="text-sm font-semibold">Group Members</div>
                  <ul className="mt-3 space-y-2">
                    {(GroupMembersData?.length
                      ? GroupMembersData.slice(0, 6)
                      : []
                    )?.map((user) => {
                      const label =
                        `${user?.first_name} ${user?.last_name}` || "Member";
                      return (
                        <li
                          key={user?.id || label}
                          className="flex items-center justify-between rounded-xl border border-[#1f2c34] bg-[white] px-3 py-2"
                        >
                          <div className="flex items-center gap-3">
                            <Avatar className="h-8 w-8">
                              <AvatarImage
                                src={user?.profile_url}
                                alt={label}
                                referrerPolicy="no-referrer"
                              />
                              <AvatarFallback>
                                {label.slice(0, 2).toUpperCase()}
                              </AvatarFallback>
                            </Avatar>
                            <div>
                              <div className="text-sm font-medium">{label}</div>
                              {user?.email && (
                                <div className="text-[11px] text-[#8696a0]">
                                  {user?.email}
                                </div>
                              )}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
